import { axiosJwt } from '@/shared/auth/axiosJwt';

const apiImpressoes = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_CHECKINS_IMPRESSOES}${process.env.VUE_APP_API_PATH}/checkins/impressoes`;

const apiInscricoes = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_CHECKINS_INSCRICOES}${process.env.VUE_APP_API_PATH}/checkins/inscricoes`;

const apiColetor = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_CHECKINS_COLETOR}${process.env.VUE_APP_API_PATH}/checkins/coletor`;

export default {
    obterDashboard() {
        return axiosJwt.get(`${apiImpressoes}/dashboard`);
    },

    obterImpressoras() {
        return axiosJwt.get(`${apiImpressoes}/impressoras`);
    },

    verificarInscricaoTotemPorCpf(payload) {
        return axiosJwt.post(`${apiInscricoes}/impressoras/verificar-totem-cpf`, payload);
    },

    emitirEtiquetaVCard(payload) {
        return axiosJwt.post(`${apiInscricoes}/impressoras/verificar-totem-vcard`, payload);
    },

    inserirCheckin(payload) {
        return axiosJwt.post(`${apiColetor}/checkins/inserir`, payload);
    },
};
